import { useTailwind } from "tailwind-rn";

import Row from "./Row";
import { TransactionDetails } from "../../../types";
import ActionButton from "../../ActionButton";
import CardText from "../../CardText";

type Props = {
  action: TransactionDetails["payment"]["availableActions"]["markAsPaid"];
};

export default function MarkAsPaidInfo({ action }: Props) {
  const tailwind = useTailwind();

  if (!action.enabled) {
    return null;
  }

  return (
    <Row style={tailwind("mt-4 items-center")}>
      <CardText.Body
        text="Revisa tu cuenta para verificar si tu cliente ha hecho el pago."
        error
        style={tailwind("flex-1 mr-4")}
      />
      <ActionButton action={action} />
    </Row>
  );
}
